import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search, MapPin, Users, Utensils } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MasterSearch({ defaultCity = "" }) {
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(defaultCity);
  const [pax, setPax] = useState("");
  const [veg, setVeg] = useState("any");
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data)).catch(() => {});
  }, []);

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    if (city) params.set("city", city);
    if (pax) params.set("pax_min", pax);
    if (veg === "veg") params.set("veg", "true");
    if (q) params.set("q", q);
    nav(`/properties?${params.toString()}`);
  };

  return (
    <form onSubmit={submit} className="bg-white/95 backdrop-blur-xl border border-[color:var(--gold)]/40 rounded-2xl shadow-2xl p-2 md:p-2.5 flex flex-col md:flex-row items-stretch gap-2" data-testid="master-search">
      <div className="flex-1 flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-[color:var(--ivory-2)] transition-colors">
        <MapPin className="w-4 h-4 text-[color:var(--wine)]"/>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest-2 text-neutral-500">City</div>
          <select value={city} onChange={(e)=>setCity(e.target.value)} className="w-full bg-transparent outline-none text-sm" data-testid="search-city">
            <option value="">All Cities</option>
            {cities.map((c) => <option key={c.name} value={c.name}>{c.name} · {c.state}</option>)}
          </select>
        </div>
      </div>
      <div className="hidden md:block w-px bg-[color:var(--line)]"/>
      <div className="flex-1 flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-[color:var(--ivory-2)] transition-colors">
        <Users className="w-4 h-4 text-[color:var(--wine)]"/>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest-2 text-neutral-500">Guests</div>
          <input type="number" value={pax} onChange={(e)=>setPax(e.target.value)} placeholder="e.g. 300" className="w-full bg-transparent outline-none text-sm" data-testid="search-pax"/>
        </div>
      </div>
      <div className="hidden md:block w-px bg-[color:var(--line)]"/>
      <div className="flex-1 flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-[color:var(--ivory-2)] transition-colors">
        <Utensils className="w-4 h-4 text-[color:var(--wine)]"/>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest-2 text-neutral-500">Cuisine</div>
          <select value={veg} onChange={(e)=>setVeg(e.target.value)} className="w-full bg-transparent outline-none text-sm" data-testid="search-veg">
            <option value="any">Veg / Non-veg</option>
            <option value="veg">Pure Veg</option>
          </select>
        </div>
      </div>
      <div className="hidden md:block w-px bg-[color:var(--line)]"/>
      <div className="flex-1 flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-[color:var(--ivory-2)] transition-colors">
        <Search className="w-4 h-4 text-[color:var(--wine)]"/>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-widest-2 text-neutral-500">Keywords</div>
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="lawn, palace, mandap…" className="w-full bg-transparent outline-none text-sm" data-testid="search-q"/>
        </div>
      </div>
      <button type="submit" className="btn-wine md:ml-1 justify-center" data-testid="search-submit">
        <Search className="w-4 h-4"/> Search
      </button>
    </form>
  );
}
